import { unselectAllImagesAction } from 'editor/src/store/gallery/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const unselectAllImagesOperation = () => (dispatch: ThunkDispatch) => {
  dispatch(unselectAllImagesAction());
};

export default unselectAllImagesOperation;
